"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2000],{

/***/ 22000:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Jumbotron; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./helpers/i18n.ts + 7 modules
var i18n = __webpack_require__(72462);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./helpers/class/Checkers.ts
var Checkers = __webpack_require__(55791);
// EXTERNAL MODULE: ./helpers/class/Consts.ts
var Consts = __webpack_require__(77245);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(71911);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./node_modules/swiper/modules/thumbs/thumbs.min.css
var thumbs_min = __webpack_require__(75083);
// EXTERNAL MODULE: ./node_modules/swiper/modules/free-mode/free-mode.min.css
var free_mode_min = __webpack_require__(30706);
// EXTERNAL MODULE: ./node_modules/swiper/modules/navigation/navigation.min.css
var navigation_min = __webpack_require__(92);
// EXTERNAL MODULE: ./components/jumbotron/Motto.tsx
var Motto = __webpack_require__(63924);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(30933);
;// CONCATENATED MODULE: ./components/jumbotron/FeaturedImagesThumbnails.tsx



// import Swiper core and required modules

// Import Swiper React components





// Import Swiper styles

// install Swiper modules
swiper_esm/* default.use */.ZP.use([
    swiper_esm/* Lazy */.oM,
    swiper_esm/* Navigation */.W_,
    swiper_esm/* Autoplay */.pt,
    swiper_esm/* Thumbs */.o3
]);
var FeaturedImagesThumbnails = function(props) {
    var ref = (0,react.useState)(null), thumbsSwiper = ref[0], setThumbsSwiper = ref[1];
    var autoplay = {
        delay: 2500,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    position: "relative"
                },
                children: [
                    props.motto != null && /*#__PURE__*/ (0,jsx_runtime.jsx)(Motto/* default */.Z, {
                        isDesktop: props.isDesktop,
                        motto: props.motto,
                        isManager: props.isManager,
                        bookingSearchbarWithBedrooms: props.bookingSearchbarWithBedrooms,
                        calendar: props.calendar,
                        sliderSearchBar: props.sliderSearchBar,
                        sliderSearchBarTop: props.sliderSearchBarTop,
                        sliderSearchBarBelowHeader: props.sliderSearchBarBelowHeader,
                        isFlexible: props.isFlexible,
                        rgbaDesignColor: props.rgbaDesignColor,
                        searchbarRadius: props.searchbarRadius,
                        searchbarShadow: props.searchbarShadow,
                        searchbarThemeColor: props.searchbarThemeColor,
                        logoDecoration: props.logoDecoration,
                        logoDecorationOriginWidth: props.logoDecorationOriginWidth,
                        logoDecorationOriginHeight: props.logoDecorationOriginHeight,
                        jumbotronTextAlign: props.jumbotronTextAlign,
                        jumbotronTextColor: props.jumbotronTextColor,
                        sliderTitleShadow: props.sliderTitleShadow,
                        sliderTitleBold: props.sliderTitleBold,
                        homeTitle: props.homeTitle,
                        homeSubtitle: props.homeSubtitle,
                        bookingTypeValue: props.bookingTypeValue,
                        webHotelierRoomCodes: props.webHotelierRoomCodes,
                        webHotelierBookUrl: props.webHotelierBookUrl,
                        propertyBookingTypeValue: props.propertyBookingTypeValue,
                        managerInfo: props.managerInfo
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                        navigation: true,
                        thumbs: thumbsSwiper && !thumbsSwiper.destroyed ? {
                            swiper: thumbsSwiper
                        } : undefined,
                        autoplay: props.jumbotronAutoplay ? autoplay : false,
                        className: "mainSwiper",
                        children: props.album !== undefined ? props.album !== null && props.album.length > 0 ? props.album.map(function(slide, key) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* SwiperSlide */.o5, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        priority: key == 0,
                                        layout: "fill",
                                        // loading={ key == 0 ? 'eager' : 'lazy'}
                                        sizes: "75vw",
                                        quality: "75",
                                        src: slide.image,
                                        alt: slide.caption ? slide.caption : "Slide-" + key,
                                        placeholder: "blur",
                                        blurDataURL: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                                    }),
                                    props.jumbotronOverlayOpacity > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "bg-overlay z-index-1",
                                        style: {
                                            backgroundColor: "rgb(0, 0, 0)",
                                            opacity: props.jumbotronOverlayOpacity
                                        }
                                    })
                                ]
                            }, key);
                        }) : "" : ""
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                onSwiper: setThumbsSwiper,
                freeMode: true,
                spaceBetween: 10,
                slidesPerView: 4,
                watchSlidesProgress: true,
                className: "thumbSwiper my-2 h-100",
                children: props.album !== undefined ? props.album !== null && props.album.length > 0 ? props.album.map(function(slide, key) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            layout: "fill",
                            priority: key == 0,
                            // loading={ key == 0 ? 'eager' : 'lazy'}
                            sizes: "30vw",
                            quality: "25",
                            src: slide.image,
                            alt: slide.caption ? slide.caption : "Slide-" + key,
                            placeholder: "blur",
                            blurDataURL: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                        })
                    }, key);
                }) : "" : ""
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/templates/properties/partials/SwipperWrapper.tsx
var SwipperWrapper = __webpack_require__(82411);
;// CONCATENATED MODULE: ./components/jumbotron/FeaturedImagesDesktop.tsx




var FeaturedImagesDesktop = function(props) {
    var pageTitle = props.hasOwnProperty("pageTitle") ? props.pageTitle : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: props.sliderThumbnails ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedImagesThumbnails, {
            isDesktop: props.isDesktop,
            album: props.album,
            motto: props.motto,
            isManager: props.isManager,
            bookingSearchbarWithBedrooms: props.bookingSearchbarWithBedrooms,
            calendar: props.calendar,
            rgbaDesignColor: props.rgbaDesignColor,
            searchbarRadius: props.searchbarRadius,
            searchbarShadow: props.searchbarShadow,
            searchbarThemeColor: props.searchbarThemeColor,
            designMode: props.designMode,
            logoDecoration: props.logoDecoration,
            logoDecorationOriginWidth: props.logoDecorationOriginWidth,
            logoDecorationOriginHeight: props.logoDecorationOriginHeight,
            jumbotronAutoplay: props.jumbotronAutoplay,
            jumbotronTextAlign: props.jumbotronTextAlign,
            jumbotronTextColor: props.jumbotronTextColor,
            sliderTitleShadow: props.sliderTitleShadow,
            sliderTitleBold: props.sliderTitleBold,
            jumbotronOverlayOpacity: props.jumbotronOverlayOpacity,
            homeTitle: props.homeTitle,
            homeSubtitle: props.homeSubtitle,
            bookingTypeValue: props.bookingTypeValue,
            webHotelierRoomCodes: props.webHotelierRoomCodes,
            webHotelierBookUrl: props.webHotelierBookUrl,
            propertyBookingTypeValue: props.propertyBookingTypeValue,
            managerInfo: props.managerInfo
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SwipperWrapper/* default */.Z, {
            images: props.album,
            imagesToShow: 6,
            galleryHeight: "100%",
            wrapperClassName: "",
            enableAutoplay: props.jumbotronAutoplay,
            designMode: props.designMode,
            spaceBetween: 0,
            customNavigationArrows: false,
            enableFancyBox: false,
            enableAlbumRightModal: props.property,
            jumbotronOverlayOpacity: props.jumbotronOverlayOpacity,
            motto: props.motto,
            isManager: props.isManager,
            bookingSearchbarWithBedrooms: props.bookingSearchbarWithBedrooms,
            calendar: props.calendar,
            sliderSearchBar: props.sliderSearchBar,
            sliderSearchBarTop: props.sliderSearchBarTop,
            sliderSearchBarBelowHeader: props.sliderSearchBarBelowHeader,
            isFlexible: props.isFlexible,
            rgbaDesignColor: props.rgbaDesignColor,
            searchbarRadius: props.searchbarRadius,
            searchbarShadow: props.searchbarShadow,
            searchbarThemeColor: props.searchbarThemeColor,
            firstSlideTitle: props.homeTitle,
            firstSlideSubtitle: props.homeSubtitle,
            logoDecoration: props.logoDecoration,
            logoDecorationOriginWidth: props.logoDecorationOriginWidth,
            logoDecorationOriginHeight: props.logoDecorationOriginHeight,
            jumbotronTextAlign: props.jumbotronTextAlign,
            jumbotronTextColor: props.jumbotronTextColor,
            sliderTitleShadow: props.sliderTitleShadow,
            sliderTitleBold: props.sliderTitleBold,
            pageTitle: pageTitle,
            bookingTypeValue: props.bookingTypeValue,
            webHotelierRoomCodes: props.webHotelierRoomCodes,
            webHotelierBookUrl: props.webHotelierBookUrl,
            propertyBookingTypeValue: props.propertyBookingTypeValue,
            managerInfo: props.managerInfo
        }, "featured-image-swiper")
    });
};

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/CustomModal.tsx
var CustomModal = __webpack_require__(89929);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var pro_solid_svg_icons = __webpack_require__(73582);
// EXTERNAL MODULE: ./components/jumbotron/GridImagesDesktop.tsx
var GridImagesDesktop = __webpack_require__(23597);
;// CONCATENATED MODULE: ./components/Jumbotron.tsx








var ModalPropertyImages = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 63644));
}, {
    ssr: false
});






function Jumbotron(props) {
    var pageTitle = props.hasOwnProperty("pageTitle") ? props.pageTitle : "";
    var t = (0,i18n/* useT */.NT)();
    var fullHeight = props.video == null && props.propertyJumbotronType == Consts/* default.JumbotronGridImage */.Z.JumbotronGridImage && !props.forceSwiperSingleImage && Checkers/* default.isValidArray */.Z.isValidArray(props.album) && props.album.length >= 1 ? false : true;
    var isDesktop = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["isDesktop"];
    });
    var ref = (0,react.useState)("close"), modalState = ref[0], setModalState = ref[1];
    var videoUrl = props.details != undefined && props.details.hasOwnProperty("video_url") ? props.details.video_url : null;
    var _isFlexible = props.isFlexible, isFlexible = _isFlexible === void 0 ? false : _isFlexible;
    var handleShow = function(state) {
        setModalState(state);
    };
    var handleHide = function() {
        setModalState("close");
    };
    var jumbotronHeight = null;
    var jumbotronOverlayOpacity = null;
    // props.video = videoUrl;
    var property = props.hasOwnProperty("property") && props.property;
    if (!property) {
        if (props.sliderThumbnails) if (props.jumbotronHeight > 0) jumbotronHeight = props.jumbotronHeight + "vh";
        else jumbotronHeight = "85vh";
        else if (props.jumbotronHeight > 0) jumbotronHeight = props.jumbotronHeight + "vh";
        else jumbotronHeight = "85vh";
        if (props.jumbotronOverlayOpacity >= 0) jumbotronOverlayOpacity = props.jumbotronOverlayOpacity / 100;
        else jumbotronOverlayOpacity = "0.3";
    } else {
        if (props.propertyJumbotronHeight > 0) jumbotronHeight = props.propertyJumbotronHeight + "vh";
        else jumbotronHeight = "85vh";
        if (props.propertyJumbotronOverlayOpacity >= 0) jumbotronOverlayOpacity = props.propertyJumbotronOverlayOpacity / 100;
        else jumbotronOverlayOpacity = "0.3";
    }
    var jumbotronClass = null;
    // if ( props.sliderSearchBar ) {
    //   jumbotronClass = 'jumbotron bg-master-light overflow-visible';
    // } else {
    //   jumbotronClass = 'jumbotron bg-master-light';
    // }
    // if ( props.jumbotronClass ) {
    //   jumbotronClass += `\ ${props.jumbotronClass}`;
    // }
    var image = Checkers/* default.isValidArray */.Z.isValidArray(props.album) ? props.album[0].image : props.property && Checkers/* default.isValidString */.Z.isValidString(props.pageImage) ? props.pageImage : null;
    var albumCount = Checkers/* default.isValidArray */.Z.isValidArray(props.album) ? props.album.length : 0;
    var jumbotronHeightConst = jumbotronHeight;
    if (fullHeight) {
        if (Checkers/* default.objChildExists */.Z.objChildExists(props, "propertyJumbotronType") && props.propertyJumbotronType != undefined && !isDesktop) {
            jumbotronHeightConst = "75vw";
        }
    } else {
        jumbotronHeightConst = "auto";
    }
    if (Checkers/* default.objChildExists */.Z.objChildExists(props, "children") && props.children) {
        var height = "500px";
        var jumbotronClass1 = "jumbotron ";
        if (Checkers/* default.isValidString */.Z.isValidString(props.jumbotronClass)) {
            jumbotronClass1 += props.jumbotronClass;
        }
        if (Checkers/* default.isValidNumber */.Z.isValidNumber(props.jumbotronHeight)) {
            height = props.jumbotronHeight + "vh";
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: jumbotronClass1,
            style: {
                height: height
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: props.children
            })
        });
    }
    var openPropertiesImageModal = function() {
        if (Checkers/* default.objChildExists */.Z.objChildExists(props, "propertyJumbotronType") && props.propertyJumbotronType == Consts/* default.JumbotronStaticImage */.Z.JumbotronStaticImage) {}
    };
    var jumbotronContentHandler = function() {
        var ref, ref1;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: props.album !== undefined ? props.album !== null ? props.video != null ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    props.isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                        id: "my-player",
                        className: "video-js",
                        loop: true,
                        muted: true,
                        autoPlay: true,
                        preload: "auto",
                        poster: props.album[0].jpg,
                        style: {
                            backgroundColor: "rgb(0, 0, 0)",
                            position: "absolute",
                            width: "100%",
                            height: jumbotronHeightConst,
                            objectFit: "cover",
                            objectPosition: "center"
                        },
                        "data-setup": "{}",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                            src: props.video
                        })
                    }) : "",
                    image != null && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: props.sliderSearchBar || props.sliderSearchBarBelowHeader || props.sliderSearchBarTop ? "swiper overflow-visible" : "swiper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "swiper-wrapper",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "swiper-slide",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            priority: true,
                                            className: "visible-xs visible-sm",
                                            layout: "fill",
                                            // sizes={'75vw'}
                                            quality: "100",
                                            src: image,
                                            alt: "Jumbotron Img test-2",
                                            placeholder: "blur",
                                            blurDataURL: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Motto/* default */.Z, {
                                            isDesktop: props.isDesktop,
                                            isManager: props.isManager,
                                            hideMotto: true,
                                            designMode: props.designMode,
                                            searchbarThemeColor: props.searchbarThemeColor,
                                            rgbaDesignColor: props.rgbaDesignColor,
                                            sliderSearchBar: props.sliderSearchBar,
                                            sliderSearchBarTop: props.sliderSearchBarTop,
                                            sliderSearchBarBelowHeader: props.sliderSearchBarBelowHeader,
                                            searchbarRadius: props.searchbarRadius,
                                            searchbarShadow: props.searchbarShadow,
                                            bookingSearchbarWithBedrooms: props.bookingSearchbarWithBedrooms,
                                            isFlexible: isFlexible,
                                            bookingTypeValue: props.bookingTypeValue,
                                            webHotelierRoomCodes: props.webHotelierRoomCodes,
                                            webHotelierBookUrl: props.webHotelierBookUrl,
                                            propertyBookingTypeValue: props.propertyBookingTypeValue,
                                            managerInfo: props.managerInfo
                                        })
                                    ]
                                })
                            })
                        })
                    })
                ]
            }) : props.album.length == 1 && !props.forceSwiperSingleImage && !(property && props.propertyJumbotronType == Consts/* default.JumbotronGridImage */.Z.JumbotronGridImage) || Checkers/* default.objChildExists */.Z.objChildExists(props, "propertyJumbotronType") && props.propertyJumbotronType == Consts/* default.JumbotronStaticImage */.Z.JumbotronStaticImage ? image != null && Checkers/* default.isValidString */.Z.isValidString(image) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: props.sliderSearchBar || props.sliderSearchBarBelowHeader || props.sliderSearchBarTop ? "swiper overflow-visible" : "swiper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "swiper-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "swiper-slide",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        // priority={true}
                                        // layout={'fill'}
                                        // sizes={'100vw'}
                                        // quality={'100'}
                                        src: image,
                                        alt: props.album[0].caption ? props.album[0].caption : "Jumbotron Img test-1",
                                        placeholder: "blur",
                                        className: "h-100 w-100"
                                    }),
                                    props.withMotto && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Motto/* default */.Z, {
                                                isDesktop: props.isDesktop,
                                                isManager: props.isManager,
                                                motto: props.content.motto,
                                                logoDecoration: props.logoDecoration,
                                                logoDecorationOriginWidth: props.logoDecorationOriginWidth,
                                                logoDecorationOriginHeight: props.logoDecorationOriginHeight,
                                                jumbotronTextAlign: props.jumbotronTextAlign,
                                                jumbotronTextColor: props.jumbotronTextColor,
                                                sliderTitleShadow: props.sliderTitleShadow,
                                                sliderTitleBold: props.sliderTitleBold,
                                                homeTitle: props.homeTitle,
                                                homeSubtitle: props.homeSubtitle,
                                                // hideMotto={props.sliderSearchBar}
                                                sliderSearchBar: props.sliderSearchBar,
                                                sliderSearchBarTop: props.sliderSearchBarTop,
                                                sliderSearchBarBelowHeader: props.sliderSearchBarBelowHeader,
                                                rgbaDesignColor: props.rgbaDesignColor,
                                                searchbarRadius: props.searchbarRadius,
                                                searchbarShadow: props.searchbarShadow,
                                                designMode: props.designMode,
                                                searchbarThemeColor: props.searchbarThemeColor,
                                                bookingSearchbarWithBedrooms: props.bookingSearchbarWithBedrooms,
                                                isFlexible: isFlexible,
                                                calendar: props.calendar,
                                                bookingTypeValue: props.bookingTypeValue,
                                                webHotelierRoomCodes: props.webHotelierRoomCodes,
                                                webHotelierBookUrl: props.webHotelierBookUrl,
                                                propertyBookingTypeValue: props.propertyBookingTypeValue,
                                                managerInfo: props.managerInfo
                                            }),
                                            jumbotronOverlayOpacity > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "bg-overlay",
                                                style: {
                                                    backgroundColor: "rgb(0, 0, 0)",
                                                    opacity: jumbotronOverlayOpacity
                                                }
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "container position-relative d-flex justify-content-end",
                            children: property && Checkers/* default.objChildExists */.Z.objChildExists(props, "propertyJumbotronType") && props.propertyJumbotronType == Consts/* default.JumbotronStaticImage */.Z.JumbotronStaticImage && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "position-absolute z-index-2 pb-5",
                                style: {
                                    bottom: 0,
                                    right: 0
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        id: "jumbotron_show_modal",
                                        type: "button",
                                        className: "btn btn-cons btn-lg text-master no-margin",
                                        onClick: function() {
                                            return handleShow("property_photos_modal");
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                icon: pro_solid_svg_icons/* faGrid */.Vr3,
                                                className: "fs-18 m-r-10"
                                            }),
                                            t("common.showPhotos")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomModal/* default */.Z, {
                                        modalName: "property_photos_modal",
                                        className: "slide_right",
                                        modalSize: "lg",
                                        closeModal: function() {
                                            handleHide();
                                        },
                                        show: modalState === "property_photos_modal",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalPropertyImages, {
                                            all_images: props.album,
                                            handleHide: handleHide
                                        })
                                    }),
                                    props.album.map(function(media, index) {
                                        if (index > 0) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "hidden",
                                                "data-fancybox": "jumbotron-images",
                                                "data-src": media.image,
                                                "data-caption": media.caption,
                                                "data-thumb": media.image
                                            }, media.image_id.toString());
                                        }
                                    })
                                ]
                            })
                        })
                    })
                ]
            }) : props.album.length > 1 || props.forceSwiperSingleImage || property && props.propertyJumbotronType == Consts/* default.JumbotronGridImage */.Z.JumbotronGridImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "test-1 inner " + (fullHeight ? "full-height" : ""),
                    children: [
                        (props.propertyJumbotronType != Consts/* default.JumbotronGridImage */.Z.JumbotronGridImage || props.forceSwiperSingleImage) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedImagesDesktop, {
                                sliderThumbnails: props.sliderThumbnails,
                                isDesktop: props.isDesktop,
                                album: props.album,
                                pageTitle: pageTitle,
                                motto: props.motto,
                                isManager: props.isManager,
                                bookingSearchbarWithBedrooms: props.bookingSearchbarWithBedrooms,
                                calendar: props.calendar,
                                sliderSearchBar: props.sliderSearchBar,
                                sliderSearchBarTop: props.sliderSearchBarTop,
                                sliderSearchBarBelowHeader: props.sliderSearchBarBelowHeader,
                                isFlexible: isFlexible,
                                rgbaDesignColor: props.rgbaDesignColor,
                                searchbarRadius: props.searchbarRadius,
                                searchbarShadow: props.searchbarShadow,
                                searchbarThemeColor: props.searchbarThemeColor,
                                designMode: props.designMode,
                                logoDecoration: props.logoDecoration,
                                logoDecorationOriginWidth: props.logoDecorationOriginWidth,
                                logoDecorationOriginHeight: props.logoDecorationOriginHeight,
                                jumbotronAutoplay: props.jumbotronAutoplay,
                                jumbotronTextAlign: props.jumbotronTextAlign,
                                jumbotronTextColor: props.jumbotronTextColor,
                                sliderTitleShadow: props.sliderTitleShadow,
                                sliderTitleBold: props.sliderTitleBold,
                                jumbotronOverlayOpacity: jumbotronOverlayOpacity,
                                homeTitle: props.homeTitle,
                                homeSubtitle: props.homeSubtitle,
                                property: property,
                                bookingTypeValue: props.bookingTypeValue,
                                webHotelierRoomCodes: props.webHotelierRoomCodes,
                                webHotelierBookUrl: props.webHotelierBookUrl,
                                propertyBookingTypeValue: props.propertyBookingTypeValue,
                                managerInfo: props.managerInfo
                            })
                        }),
                        property && props.propertyJumbotronType == Consts/* default.JumbotronGridImage */.Z.JumbotronGridImage && !props.forceSwiperSingleImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GridImagesDesktop/* GridImagesDesktop */.E, {
                                sliderThumbnails: props.sliderThumbnails,
                                isDesktop: props.isDesktop,
                                isManager: props.isManager,
                                album: props.album,
                                motto: props.motto,
                                altTitle: ((ref = props.details) === null || ref === void 0 ? void 0 : ref.property_title) || ((ref1 = props.content) === null || ref1 === void 0 ? void 0 : ref1.property_title) || pageTitle,
                                designMode: props.designMode,
                                logoDecoration: props.logoDecoration,
                                logoDecorationOriginWidth: props.logoDecorationOriginWidth,
                                logoDecorationOriginHeight: props.logoDecorationOriginHeight,
                                jumbotronAutoplay: props.jumbotronAutoplay,
                                jumbotronTextAlign: props.jumbotronTextAlign,
                                jumbotronTextColor: props.jumbotronTextColor,
                                sliderTitleShadow: props.sliderTitleShadow,
                                sliderTitleBold: props.sliderTitleBold,
                                jumbotronOverlayOpacity: jumbotronOverlayOpacity,
                                homeTitle: props.homeTitle,
                                homeSubtitle: props.homeSubtitle,
                                isProperty: property,
                                handleShow: handleShow,
                                handleHide: handleHide,
                                modalState: modalState,
                                videoUrl: videoUrl
                            })
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
        });
    };
    var jumbotronContent = jumbotronContentHandler();
    return jumbotronContent.props.children != false ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: jumbotronClass + " jumbotron full-width full-vh " + (property && albumCount >= 1 && props.propertyJumbotronType == Consts/* default.JumbotronGridImage */.Z.JumbotronGridImage && !props.forceSwiperSingleImage ? "py-4" : ""),
            "data-bg-overlay": jumbotronOverlayOpacity > 0 ? "black" : "",
            "data-overlay-opacity": jumbotronOverlayOpacity,
            style: {
                height: jumbotronHeightConst
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "hidden",
                        children: "Jumbotron"
                    }),
                    jumbotronContent
                ]
            })
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
}


/***/ }),

/***/ 23597:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ GridImagesDesktop; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _helpers_i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72462);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55791);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67814);
/* harmony import */ var _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(73582);
/* harmony import */ var _CustomModal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(89929);
/* harmony import */ var _templates_property_partials_modals_ModalPropertyImages__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63644);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9473);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(32293);













var GridImagesDesktop = function(props) {
    var ref;
    var t = (0,_helpers_i18n__WEBPACK_IMPORTED_MODULE_2__/* .useT */ .NT)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var ref1;
    var currentPropertyId = (ref = String((ref1 = (0,react_redux__WEBPACK_IMPORTED_MODULE_8__/* .useSelector */ .v9)(function(state) {
        return state["propertiesParams"]["property_id"];
    })) !== null && ref1 !== void 0 ? ref1 : "").match(/^\d+/)) === null || ref === void 0 ? void 0 : ref[0];
    var albumUrl = currentPropertyId ? "/album?property_id=" + currentPropertyId : "/album";
    var showPhotosClick = !props.isManager ? function() {
        return router.push(albumUrl);
    } : function() {
        return props.handleShow("property_photos_modal");
    };
    var isDesktop = (0,react_redux__WEBPACK_IMPORTED_MODULE_8__/* .useSelector */ .v9)(function(state) {
        return state["appSettings"]["isDesktop"];
    });
    var isHomepage = (0,react_redux__WEBPACK_IMPORTED_MODULE_8__/* .useSelector */ .v9)(function(state) {
        return state["appSettings"]["isHomepage"];
    });
    var bookingSearchbarWidth = (0,react_redux__WEBPACK_IMPORTED_MODULE_8__/* .useSelector */ .v9)(function(state) {
        return state["builderSettingsData"]["settings"]["bookingSearchbarWidth"];
    });
    var isFullWidthSearchbarHomepage = isHomepage && bookingSearchbarWidth === true;
    var getGridArea = function(key) {
        if (key > 5) {
            key = (key + 1) % 6;
        }
        // key++;
        // if(key>6){
        //   key = key - (6 * (key/6));
        // // }
        //
        // console.log('debughere', 'key', key, 'mod', positionCheck)
        if (key == 0) return "boxA";
        else if (key == 1) return "boxB";
        else if (key == 2) return "boxC";
        else if (key == 3) return "boxD";
        else if (key == 4) return "boxE";
        return "boxUnkown";
    };
    var photoCount = _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidArray */ .Z.isValidArray(props.album) ? props.album.length : 0;
    var visiblePhotoCount = Math.min(photoCount, 5);
    var gridClass = photoCount <= 4 ? "property-custom-css-grid-".concat(Math.max(visiblePhotoCount, 1)) : "property-custom-css-grid";
    var showPhotosButton = photoCount > 5 || !isDesktop && photoCount > 1;
    // homepage grid: any photo click goes to the gallery page (managers keep the modal)
    var photoClickOpensGallery = showPhotosButton || isHomepage && !props.isManager;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), show = ref2[0], setShow = ref2[1];
    var closeHandler = function() {
        setShow(false);
    };
    // const urlParams = () => {
    //   if(Checkers.isValidString(props.videoUrl))
    //     return null
    //
    //   return new URLSearchParams(props.videoUrl);
    // }
    var getVideoParam = function() {
        if (!_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(props.videoUrl) || props.videoUrl == 0) {
            return null;
        }
        if (!_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(props.videoUrl)) {
            return null;
        }
        var params = new URL(props.videoUrl).searchParams;
        var videoParam = params.get("v");
        return videoParam;
    };
    var videoHandler = function(event) {
        setShow(true);
        event.preventDefault();
        event.stopPropagation();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "container d-flex",
                onClick: photoClickOpensGallery ? showPhotosClick : undefined,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "panel panel-transparent w-100",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "panel-body p-0",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: gridClass,
                            children: props.album && props.album.map(function(item, index) {
                                return index < visiblePhotoCount && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: getGridArea(index),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "card social-card share full-width full-height",
                                            style: {
                                                overflow: "hidden",
                                                cursor: "pointer"
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
                                                className: "card-content"
                                            }, !photoClickOpensGallery ? {
                                                "data-fancybox": "jumbotron-images",
                                                "data-src": item.image,
                                                "data-thumb": item.image
                                            } : {}), {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                        alt: _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(item.caption) ? _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].removeEmojis */ .Z.removeEmojis(item.caption) : _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(props.altTitle) ? props.altTitle + (index > 0 ? " - " + (index + 1) : "") : item.meta_title ? _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].removeEmojis */ .Z.removeEmojis(item.meta_title) : _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].removeEmojis */ .Z.removeEmojis(item.title) || "Social post-" + index,
                                                        src: _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(item.image_webp) ? item.image_webp : item.image,
                                                        onError: function(event) {
                                                            // a webp that is missing on the cdn falls back to the original image (only once, no loop)
                                                            var target = event.currentTarget;
                                                            if (_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(item.image) && target.getAttribute("src") !== item.image) {
                                                                target.setAttribute("src", item.image);
                                                            }
                                                        }
                                                    }),
                                                    getVideoParam() != null && index == 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            onClick: videoHandler,
                                                            className: "video-overlay d-flex justify-content-center align-items-center",
                                                            style: {
                                                                position: "absolute",
                                                                top: 0,
                                                                left: 0,
                                                                width: "100%",
                                                                height: "100%",
                                                                backgroundColor: "rgba(0,0,0,0.3)"
                                                            },
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                    className: "fa-solid fa-play fa-2x text-white"
                                                                })
                                                            })
                                                        })
                                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
                                                ]
                                            }))
                                        })
                                    })
                                });
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "container position-relative d-flex justify-content-end",
                    children: showPhotosButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "position-absolute z-index-2 pe-3 pb-4",
                            style: {
                                bottom: 0,
                                right: 0
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                    id: "jumbotron_show_modal",
                                    type: "button",
                                    className: "btn btn-cons btn-lg text-master no-margin",
                                    onClick: showPhotosClick,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_5__/* .FontAwesomeIcon */ .G, {
                                            icon: _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_11__/* .faGrid */ .Vr3,
                                            className: "fs-18 m-r-10"
                                        }),
                                        t("common.showPhotos")
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomModal__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    modalName: "property_photos_modal",
                                    className: "slide_right",
                                    modalSize: "lg",
                                    closeModal: function() {
                                        var ref;
                                        (ref = props.handleHide) === null || ref === void 0 ? void 0 : ref.call(props);
                                    },
                                    show: props.modalState === "property_photos_modal",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_templates_property_partials_modals_ModalPropertyImages__WEBPACK_IMPORTED_MODULE_7__["default"], {
                                        all_images: props.album,
                                        handleHide: props.handleHide
                                    })
                                }),
                                props.album.map(function(media, index) {
                                    if (index > 0) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "hidden",
                                            "data-fancybox": "jumbotron-images",
                                            "data-src": media.image,
                                            "data-caption": media.caption,
                                            "data-thumb": media.image
                                        }, media.image_id != null ? media.image_id.toString() : index);
                                    }
                                })
                            ]
                        })
                    })
                })
            }),
            getVideoParam() != null ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                    className: "border-0 xxl transparent-content",
                    size: "xl",
                    show: show,
                    onHide: closeHandler,
                    animation: isDesktop ? true : false,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
                                width: "840",
                                height: "472",
                                src: "https://www.youtube.com/embed/" + getVideoParam(),
                                style: {
                                    maxWidth: "100%"
                                },
                                title: "YouTube video player",
                                frameBorder: "0",
                                allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                                allowFullScreen: true
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                onClick: closeHandler,
                                className: "btn btn-lg btn-primary btn-design-color w-auto close_button",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_5__/* .FontAwesomeIcon */ .G, {
                                        icon: _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_11__/* .faX */ .EOp,
                                        className: "fs-18 m-r-10 b-r-1"
                                    }),
                                    t("common.close")
                                ]
                            })
                        ]
                    })
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
        ]
    });
};


/***/ })

}]);